import React from 'react';
import { AlertTriangle } from 'lucide-react';
import './CancellationCallout.css';

/**
 * F4 — Amber callout shown when the cancellation window is set to 0.
 *
 * Cancellations are then unrestricted, so we surface the no-show risk
 * inline with the input rather than burying it in a tooltip.
 */
const CancellationCallout = () => (
  <div className="appointments-v3-cancel-callout" role="note">
    <AlertTriangle size={14} strokeWidth={2.5} aria-hidden="true" />
    <span>
      Set to 0 — customers can cancel anytime, including last-minute and no-shows.
    </span>
  </div>
);

export default CancellationCallout;
